// extracted by mini-css-extract-plugin
module.exports = {"container":"rich-text-wrapper_container__p2bdw","containerExtraBottomSpacing":"rich-text-wrapper_containerExtraBottomSpacing__1oRAx"};